import React from 'react'
import { ModalConsulta } from '.';
import { Tabela } from '../Basicos';

function ModalConsultaLogMudancaGrupo(props) {
    const { estrutura } = props;
    const { logs } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "Log",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Data/Hora',
                    accessor: 'data_hora',
                },
                {
                    Header: 'Aluno',
                    accessor: 'aluno',
                },
                {
                    Header: 'Matrícula',
                    accessor: 'matricula',
                },
                {
                    Header: 'Quem fez',
                    accessor: 'quem_fez',
                },
                {
                    Header: 'Origem',
                    accessor: 'origem',
                },
                {
                    Header: 'Ação',
                    accessor: 'acao',
                },
                {
                    Header: 'Grupo anterior',
                    accessor: 'grupo_anterior',
                },
                {
                    Header: 'Grupo novo',
                    accessor: 'grupo_novo',
                },
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"

            {...props}
        >
            <Tabela
                columns={columns}
                data={logs}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaLogMudancaGrupo;
